import { AuctionDrugItem } from './auction-drug-item';

export type AuctionType = 'Regular' | 'Project';

export class Auction {

  constructor() { }

  code: string;
  type: AuctionType;
  contractor: string;
  costAuction: string;
  dateAuction: string;
  dateSubmission: string;
  distributerLogistic: string;
  distributerParticipant: string;
  distributerParticipant2: string;
  distributerParticipant3: string;
  distributerParticipantSAI1: string;
  distributerParticipantSAI2: string;

  distributerWinner: string;
  manager: string;
  region: string;
  status: string;
  parent: string;
  deliveryInformationDate: string;
  typeLow: string;
  typeMail: string;
  authOrganization: string;
  specification: string;
  comment: string;
  primaryContract: string;
  isQuantityUndefined: boolean;
  amountPosition: number;
  drugs: AuctionDrugItem[];
  statusST: string;
  iasDataErrorList: string;
  totalAgreedIncreaseOfNMC: number;
  totalAgreedIncreaseOfCK: number;
  totalAgreedIncreaseOfNMCCOLOR: string;
  totalAgreedIncreaseOfCKCOLOR: string;
  kpNum: number;
  contractSum: number;
  contractSumColor: string;
  contractSumError: number;
  delta: number;
}



// WEBPACK FOOTER //
// ./src/app/modules/home/models/auction.ts